/* Ovejeros – scroll-reveal con IntersectionObserver
   Aplica .is-revealed cuando la sección entra al viewport.
   Respeta prefers-reduced-motion (el CSS ya lo neutraliza). */
(function () {
  'use strict';

  var SELECTORS = [
    '[data-reveal]',
    '.slider-content',
    '.icon-rows',
    '.custom-banner',
    '.collection-list',
    '.featured-collection',
    '.banner-grid',
    '.testimonial',
    '.instagram-main'
  ].join(',');

  function reveal(els) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  function init() {
    var nodes = document.querySelectorAll(SELECTORS);
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      reveal(nodes);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    nodes.forEach(function (n) {
      // El hero entra de inmediato
      if (n.classList.contains('slider-content')) {
        requestAnimationFrame(function () { n.classList.add('is-revealed'); });
      } else {
        io.observe(n);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
